import { observer } from "mobx-react-lite";
import * as React from "react";

import { getTheme } from "./getTheme";

export const theme = getTheme().getThemeData.get();
export type TEt3Theme = typeof theme;
const MyContext = React.createContext(theme);

export const ThemeProvider = (props: {
  children: any;
  themeValue: TEt3Theme;
}) => {
  const { children, themeValue } = props;
  return <MyContext.Provider value={themeValue}>{children}</MyContext.Provider>;
};

export const withTheme = <P extends object>(
  Component: React.ComponentType<P>
) => {
  const ComponentWithTheme: React.ComponentType<P> = (props) => {
    return (
      <MyContext.Consumer>
        {(theme: TEt3Theme) => {
          const propsWithTheme = {
            ...props,
            theme
          };
          return React.createElement(Component, propsWithTheme);
        }}
      </MyContext.Consumer>
    );
  };
  return observer(ComponentWithTheme);
};
